<script setup lang="ts">
import { Head, router } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFilePdf, faTimes, faPaperclip } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
import { useFormatTime } from '@/Composables/useFormatTime'
import { useFormatCurrency } from '@/Composables/useFormatCurrency'
import { inject, ref, watch } from 'vue'
import Tag from '@/Components/Utils/Tag.vue'
import { routeType } from '@/types/route'
import { aikuLocaleStructure } from '@/Composables/useLocaleStructure'
import OrdersListSales from '@/Pages/Master/Invoices/OrdersListSales.vue'
import Button from '@/Components/Utils/Button.vue'
import { Dialog, Popover, ProgressBar } from 'primevue'
import LoadingIcon from '@/Components/Utils/LoadingIcon.vue'
import { useTruncate } from '@/Composables/useTruncate'
library.add(faFilePdf, faTimes, faPaperclip)


const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    files: {}[]
    invoice: {
        id: number
        orders: {
            id: number
            reference: string
            total: number
            product: {
                id: number
                name: string
            }
            quantity: number
            total_amount: number
        }[]
        reference: string
        total_amount: number
        created_at: string
        sales: {
            id: number
            name: string
        }
        billing_date: string | null
        type: string
        type_label: string
    }
    invoice_cash: {}
    invoice_type: {
        label: string
        value: string
    }[]
    // profile_company: {
    //     name: string
    //     address: string
    //     phone: string
    // }
    // pdf_route?: routeType
}>()


const locale = inject('locale', aikuLocaleStructure)


const isLoadingUpload = ref(false)
const progress = ref(null)
const uploadFile = async (event) => {
    let file = event.target.files[0];
    if (!file) return;

    let formData = new FormData();
    formData.append("file", file);

    console.log('formdata', formData);

    router.post(
        route('sales.invoices.upload-image', props.invoice?.id),
        {
            image: file,
        },
        {
            headers: { "Content-Type": "multipart/form-data" },
            onStart: () => {
                isLoadingUpload.value = true
                message.value = null
            },
            onProgress: (e) => {
                progress.value = e
            },
            onFinish: () => {
                // setTimeout(() => {
                    isLoadingUpload.value = false
                    progress.value = null
                    isShowSkeleton.value = false
                // }, 10)

                setTimeout(() => {
                    isShowSkeleton.value = false
                }, 1000)
            },
            onError: (e) => {
                message.value = e.image;
            }
        }
    )
}


const isShowSkeleton = ref(false)
watch(progress, (value) => {
    if (value?.percentage === 100){
        setTimeout(() => {
            isLoadingUpload.value = false
            isShowSkeleton.value = true
        }, 600)
    }
})

// Section: Upload image
const message = ref("");
const isModalBuktiPelunasan = ref(false)
const isDeleteFile = ref<number[]>([])
const onDeleteImage = (idImage: number) => {
    // console.log('idImage', idImage)
    if (!idImage) return

    router.delete(
        route('sales.invoices.delete-image', idImage),
        {
            onStart: () => {
                isDeleteFile.value.push(idImage)
            },
            onFinish: () => {
                isDeleteFile.value = isDeleteFile.value.filter(id => id !== idImage)
                _popover_delete.value?.hide()
            },
            onError: (e) => {
                // message.value = e.image;
            }
        }
    )
}
const selectedIdImageToDelete = ref<number | null>(null)
const _popover_delete = ref(null)
const openPopoverDelete = (e, idImage?: number) => {
    if (idImage) {
        selectedIdImageToDelete.value = idImage
    } else {
        selectedIdImageToDelete.value = null
    }
    _popover_delete.value?.toggle(e)
}
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead">
        <template #afterTitle>
            <Tag v-if="invoice.billing_date && (invoice_cash ? invoice_cash.billing_date : true)" v-tooltip="useFormatTime(invoice.billing_date, {formatTime: 'hms'})" :theme="3" size="sm" noHoverColor>
                <template #label>
                    <FontAwesomeIcon icon='fal fa-check' class='' fixed-width aria-hidden='true' />
                    Lunas
                </template>
            </Tag>
        </template>
    </PageHeading>

    <div class="mx-8 mt-8">
        <!-- Button: Bukti pelunasan -->
        <div class="">
            <Button v-if="files.length" @click="isModalBuktiPelunasan = true" icon="fal fa-paperclip" :label="`bukti pelunasan (${files.length})`" type="secondary" />
            <Button v-else @click="isModalBuktiPelunasan = true" icon="fal fa-plus" :label="`Tambah bukti pelunasan`" type="primary" />
        </div>
        
        <div class="pt-6 w-full grid grid-cols-1 xl:grid-cols-2 gap-y-6 gap-x-14">
            <!-- Section: Invoice -->
            <div class="">
                <OrdersListSales
                    v-if="invoice?.orders?.length"
                    :invoice
                />
                <div v-else class="text-center italic text-gray-400 mt-16 xl:mt-32">
                    Tidak ada invoice transfer
                </div>
            </div>

            <!-- Section: Invoice cash -->
            <div class="pt-8 xl:pt-0 border-t border-dashed border-gray-300 xl:border-0">
                <OrdersListSales
                    v-if="invoice_cash?.orders?.length"
                    :invoice="invoice_cash"
                />
                <div v-else class="text-center italic text-gray-400">
                    Tidak ada invoice cash
                </div>
            </div>
        </div>
    </div>

    <Dialog
        :visible="isModalBuktiPelunasan" 
        :dismissableMask="true"
        :closable="true"
        modal
        :header="`Bukti pelunasan (${files.length})`"
        :style="{
            width: '70vw',
        }"
        :breakpoints="{ '1000px': '75vw', '575px': '90vw' }"
        @update:visible="(e: boolean) => isModalBuktiPelunasan = e"
    >
        <div class="">
            
            <input type="file" @change="uploadFile" id="input-avatar-large" name="input-avatar-large" class="sr-only" accept="image/*" />
            
            
            <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-6">
                <div v-for="file in files" :key="file.id" class="grid items-center border rounded-md border-gray-300 bg-gray-100 w-full h-64 relative">
                    <img :src="file.file_path" class="mx-auto h-fit max-h-full" />

                    <div class="absolute top-2 right-2">
                        <Button @click="(e) => openPopoverDelete(e, file.id)" type="negative" icon="far fa-trash-alt" />
                    </div>

                    <div class="absolute break-all bottom-0 px-2 text-xs flex items-end py-2 text-white h-14 bg-gradient-to-t from-gray-800/80 via-gray-800/40 to-gray-800/0 w-full">
                        {{ useTruncate(file.file_name, 42) }}
                    </div>
                </div>

                <div v-if="isShowSkeleton" class="skeleton w-full h-64 rounded-lg relative">
                </div>
                
                <div class="border border-dashed border-gray-400 rounded-xl w-full h-64 flex flex-col items-center justify-center relative overflow-hidden"
                    :class="message ? 'errorShake' : ''"
                >
                    <div v-if="isLoadingUpload" class="w-full flex flex-col items-center justify-center">
                        <LoadingIcon class="text-5xl" />
                        <span class="text-xl" :class="progress?.percentage === 100 ? 'text-green-500' : 'text-gray-400'">{{ progress?.percentage || 0 }}%</span>
                    </div>
                    <label v-else id="input-avatar-large-mask" for="input-avatar-large" class="absolute inset-0 flex flex-col items-center justify-center bg-gray-50 hover:bg-gray-200 cursor-pointer"
                    >
                        <FontAwesomeIcon icon='fal fa-plus' class='text-5xl' fixed-width aria-hidden='true' />
                        <span>Pilih gambar</span>
                        <span class="text-gray-400">(.jpeg, .jpg, .png)</span>
                        <div v-if="message" class="absolute bottom-2 text-red-500 italic text-sm">
                            *{{ message }}
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </Dialog>

    <Popover ref="_popover_delete">
        <p class="mb-2 font-semibold">Hapus bukti pelunasan?</p>
        <div class="w-64 flex gap-x-2 flex-nowrap">
            <Button @click="() => _popover_delete?.toggle(e)" type="tertiary" label="Batal" full />
            <Button @click="() => onDeleteImage(selectedIdImageToDelete)" type="red" label="Ya, hapus" :loading="isDeleteFile.includes(selectedIdImageToDelete)" />
        </div>
    </Popover>
</template>

<style scoped>
.invoice-box {
    max-width: 800px;
    margin: auto;
    padding: 30px;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    font-size: 16px;
    line-height: 24px;
    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
}

.invoice-box table {
    width: 100%;
    line-height: inherit;
    text-align: left;
}

.invoice-box table td {
    padding: 5px;
    vertical-align: top;
}

.invoice-box table tr td:nth-child(2) {
    text-align: right;
}

/* .invoice-box table tr.top table td {
    padding-bottom: 20px;
} */

/* .invoice-box table tr.top table td.title {
    font-size: 45px;
    line-height: 45px;
    color: #333;
} */

.invoice-box table tr.information table td {
    padding-bottom: 40px;
}

.invoice-box table tr.heading td {
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
}

.invoice-box table tr.details td {
    padding-bottom: 20px;
}

.invoice-box table tr.item td {
    border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
    border-bottom: none;
}

/* .invoice-box table tr.total td:nth-child(2) {
    border-top: 2px solid #eee;
    font-weight: bold;
} */

@media only screen and (max-width: 600px) {
    .invoice-box table tr.top table td {
        width: 100%;
        display: block;
        text-align: center;
    }

    .invoice-box table tr.information table td {
        width: 100%;
        display: block;
        text-align: center;
    }
}

@page {
    size: auto;
    margin: 4mm;
}

/** RTL **/
.invoice-box.rtl {
    direction: rtl;
    font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
        sans-serif;
}

.invoice-box.rtl table {
    text-align: right;
}

.invoice-box.rtl table tr td:nth-child(2) {
    text-align: left;
}
</style>